<label class="input-label flex items-center gap-4"
  >{{ label }}
  @if (isRequired) {
    <p class="text-err">*</p>
  }
  @if (tooltipText) {
    <app-tooltip [tooltipText]="tooltipText">
      <i class="fa-solid fa-circle-question text-cb-gold text-20"></i>
    </app-tooltip>
  }
</label>
<div class="input-wrapper">
  <input class="shared-input" [class.has-toggle]="enableVisibilityToggle && type === 'password'" [type]="resolvedType" [formControl]="control" [placeholder]="placeholder" [readonly]="readonly" />
  @if (enableVisibilityToggle && type === 'password') {
    <button type="button" class="visibility-toggle" (click)="toggleVisibility($event)" [attr.aria-label]="toggleAriaLabel">
      @if (resolvedType === 'password') {
        <!-- Eye icon -->
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 5c5.5 0 9.6 4.2 11 6.9.2.4.2.8 0 1.2C21.6 15.8 17.5 20 12 20S2.4 15.8 1 13.1c-.2-.4-.2-.8 0-1.2C2.4 9.2 6.5 5 12 5zm0 2C7.8 7 4.4 10.2 3.1 12c1.3 1.8 4.7 5 8.9 5s7.6-3.2 8.9-5C19.6 10.2 16.2 7 12 7zm0 2.5A2.5 2.5 0 1 1 12 14a2.5 2.5 0 0 1 0-5z"
          />
        </svg>
      } @else {
        <!-- Eye-off icon -->
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M2.3 3.7 3.7 2.3l18 18-1.4 1.4-2.2-2.2c-1.8.9-3.8 1.5-6.1 1.5C6.5 21 2.4 16.8 1 14.1c-.2-.4-.2-.8 0-1.2.8-1.6 2.5-3.8 5-5.4L2.3 3.7zM7.6 9.1A11.3 11.3 0 0 0 3.1 13c1.3 1.8 4.7 5 8.9 5 1.7 0 3.2-.4 4.6-1l-1.9-1.9c-.7.6-1.6.9-2.7.9A3.99 3.99 0 0 1 8 12c0-1 .4-1.9 1-2.6L7.6 9.1zM12 7c-1.2 0-2.3.2-3.4.6l2 2A2.5 2.5 0 0 1 14.4 13l2.1 2.1c1.9-1.3 3.4-3 4.4-4.1C19.6 9.2 16.2 7 12 7z"
          />
        </svg>
      }
    </button>
  }
</div>
@if (control.invalid && control.touched) {
  <p class="input-err">{{ validatorErrorMessage(control.errors) }}</p>
}
